<template>
    <div>
        <div id="edit_workflow" class="collapse">
            <div class="form-horizontal throttle">
                <div class="max-w-xl">
                    <div class="mt-0 pt-4 pb-2 mb-4 d-flex flex-column">
                        <label for="name" class="col-form-label">Name</label>
                        <div>
                            <input id="name" type="text" v-model="form.name" class="form-control">
                        </div>
                    </div>
                    <div class="mt-0 py-0 mb-4 d-flex flex-column">
                        <label for="desc" class="col-form-label">Description</label>
                        <div>
                            <textarea id="desc" v-model="form.description" rows="2" class="form-control"></textarea>
                        </div>
                    </div>
                    <div class="mt-0 py-0 mb-4 d-flex flex-column">
                        <label for="desc" class="col-form-label">Add Unassigned Project(s)</label>
                        <div>
                            <vuetable
                                ref="vuetable"
                                :api-mode="false"
                                :data-manager="dataManager"
                                :fields="fields"
                                :css="css.table"
                                :per-page="perPage"
                                pagination-path="pagination"
                                noDataTemplate="No Projects Found"
                                @vuetable:pagination-data="onPaginationData"
                                @vuetable:checkbox-toggled="onCheckbox"
                                @vuetable:checkbox-toggled-all="onCheckboxAll"
                            >
                                <template slot="name" slot-scope="props">
                                    {{ props.rowData.name }}
                                </template>
                                <template slot="actions" slot-scope="props">
                                    <div class="btn-group">
                                        <a class="btn btn-sm btn-outline-secondary" 
                                            :href="`/products/?project=${props.rowData.id}&search_id=${props.rowData.user_saved_search.id}&name=${props.rowData.name}&desc=${props.rowData.desc}&query=${props.rowData.user_saved_search.data}`">
                                            <i class="fa fa-eye"></i>
                                        </a>
                                    </div>
                                </template>
                            </vuetable>
                            <div class="row d-flex justify-content-between align-items-center w-100 m-auto pb-2">
                                <span>
                                    <base-pagination-info
                                        :css="css.table"
                                        ref="paginationInfo"
                                    ></base-pagination-info>
                                </span>
                                <span>
                                    <base-pagination
                                        ref="pagination"
                                        @vuetable-pagination:change-page="onChangePage"
                                    ></base-pagination>
                                </span>
                            </div>
                            <div class="row d-flex justify-content-between align-items-center w-100 m-auto pb-2">
                                <button class="btn btn-sm btn-primary" @click="addProjects">
                                    Add Project(s)
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="mt-0 py-0 mb-4 d-flex flex-column">
                        <div class="d-flex flex-column">
                            <div class="mb-1">
                                <button class="btn btn-link text-muted px-0 d-flex" @click.prevent="openRestrictUserModal">
                                    Restrict to Users +
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-secondary" data-toggle="collapse" data-target="#create_record">
                                    Cancel
                                </button>
                                <button class="btn btn-primary" type="submit" @click.prevent="handleUpdateWorkflow" :disabled="!form.name.length">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="restrictUserModal" class="modal-wrapper">
                <div class="modal-bg" @click.prevent="restrictUserModal = false"></div>
                <workflow-restrict-user :pending-users="pendingWorkflowUsers" :pending-roles="pendingWorkflowRoles" :workflow-id="workflow.id"></workflow-restrict-user>
            </div>
        </div>
    </div>
</template>
<style scoped>
.pending-projects-list {
    border: 1px solid #dedede;
    overflow-y: scroll;
    max-height: 24vh;
    height: 100%;
}
</style>
<script>
import axios from 'axios'
import SelectItemFromAPIprovidedList from "../generic/select-item-from-api-provided-list.vue";
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "edit-workflow-form",
    props: {
        workflow: {
            type: [Object],
            required: true
        },
    },
    mounted() {
        this.getUnassignedProjects();

        this.$root.$on('refresh-unassigned-projects-listing', () => {
            this.getUnassignedProjects();
        });
    },
    data() {
        return {
            loading: true,
            restrictUserModal: false,
            assignedProjects: [],
            unassignedProjects: [],
            availableWorkflowRoles: [],
            pendingWorkflowRoles: [],
            pendingWorkflowUsers: [],
            apiURL: "/pimapi/projects",
            selectedProject: {},
            pendingProjects: [],
            perPage: 4,
            alert: {
                message: "",
                status: "",
                timeOut: 15000,
            },
            form: {
                name: this.workflow.name || '',
                description: this.workflow.description || ''
            },
            moreParams: {},
            fields: [
                {
                    name: "__checkbox",
                    titleClass: 'center aligned checkbox-title',
                    dataClass: 'right aligned'
                },
                {
                    name: "__slot:name",
                    title: "Name",
                },
                {
                    name: "__slot:actions",
                    titleClass: "actions-single-column",
                },
            ],
            css: {
                table: {
                    tableClass:
                        "table table-striped table-bordered table-middle",
                    ascendingIcon: "sort-icon-asc",
                    descendingIcon: "sort-icon-desc",
                    infoClass: "",
                },
            },
        }
    },
    components: {
        "selection-lister": SelectItemFromAPIprovidedList,
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
    },
    computed: {
        pendingProjectIds() {
            return this.pendingProjects.map((p) => p.id);
        }
    },
    watch: {
        unassignedProjects: function(n, o) {
            this.$refs.vuetable.refresh();
        }
    },
    methods: {
        async getUnassignedProjects() {

            const projects = await axios.get(`${base_url}/pimapi/projects?per_page=500`);
            const assignedWorkflowProjects = await axios.get(`${base_url}/pimapi/workflows/${this.workflow.id}/projects?per_page=500`);

            const assignedProjectIds = assignedWorkflowProjects.data.data.map((p) => p.id);
            const unassignedProjects = projects.data.data.filter((p) => !assignedProjectIds.includes(p.id));

            this.unassignedProjects = unassignedProjects;
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        clearTable() {
            this.pendingProjects = [];
            this.$refs.vuetable.selectedTo = [];
            this.$refs.vuetable.refresh();
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoaded: function () {
            this.loading = false;
        },
        onCheckbox(isChecked, row) {
            if (isChecked) {
                this.pendingProjects.push(row);
            } else {
                this.pendingProjects = this.pendingProjects.filter((pendingProject) => pendingProject.id !== row.id)
            }
        },
        onCheckboxAll(isChecked) {
            if (isChecked === false) {
                this.$refs.vuetable.selectedTo = [];
                this.pendingProjects = [];
            } else {
                let selected = this.$refs.vuetable.tableData.map(item => item);
                this.pendingProjects = this.pendingProjects.concat(selected);
            }
        },
        addProjects() {
            this.loading = true;

            axios.post(base_url + '/pimapi/workflows/' + this.workflow.id + '/projects', {
                projects: this.pendingProjectIds
            })
                .then(function(response) {

                    this.$root.$emit('refresh-workflow-projects');

                    this.$emit("alert", {
                        message: 'Successfully added project(s) to workflow',
                        status: 'alert-success'
                    });

                    this.loading = false;
                    
                    this.getUnassignedProjects();
                    
                    this.$nextTick(() => {
                        this.$vuetable.refresh();
                    });
                }.bind(this))
                .catch(function(error) {
                    this.$emit("alert", {
                        message: 'Error adding project to workflow',
                        status: 'alert-danger'
                    });

                    this.loading = false;
                }.bind(this));
        },
        handleSelectProject(a) {
            this.selectedProject = a;
        },
        handleUpdateWorkflow() {
            this.loading = true;
            
            const payload = {
                name: this.form.name,
                description: this.form.description,
            };  

            axios.put(base_url + '/pimapi/workflows/' + this.workflow.id, payload)
                .then(function (response) {
                    this.loading = false;

                    this.$parent.workflowName = payload.name;

                    this.$root.$emit('refresh-workflow-projects');

                    this.$emit("alert", {
                        message: 'Success, workflow updated',
                        status: "alert-success"   
                    });
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                    this.loading = false;

                    this.$emit("alert", {
                        message: error.response.data.message,
                        status: "alert-danger"   
                    });
                }.bind(this));
        },
        openRestrictUserModal() {
            this.restrictUserModal = true;
        },
        dataManager(sortOrder, pagination) {
            if (this.unassignedProjects.length < 1) return;

            let local = this.unassignedProjects;

            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                local,
                sortOrder[0].sortField,
                sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );

            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },
    }
};
</script>